<template>
  <Works></Works>
</template>

<script>
import Works from '@/components/Works'
export default {
  name: 'Portfolio',
  data () {
    return {
    }
  },
  components: {
    Works
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Portfolio.vue